exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.word-md-file--component-wrapper[data-v-602948f6] {\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n}\n", ""]);

// exports
